import ReactDOM from "react-dom";
import "./styles/reset.css"; // Global modern CSS reset / normalization
import Main from "./Main";

ReactDOM.render(<Main />, document.getElementById("root"));
